import classnames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import './skeleton.scss';

function Skeleton(props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return <div {...props} className={classnames('skeleton', props.className)} />;
}

export default Skeleton;
